import { FC, useState } from 'react';
import Modal, { ModalBody } from '~/components/common/modal';
import Button from '~/components/common/button';
import { Translate } from '~/i18n';

import {
   WhatsappIcon,
   TwitterIcon,
   FacebookIcon,
   LinkedinIcon,
   EmailIcon,
   FacebookShareButton,
   EmailShareButton,
   TwitterShareButton,
   LinkedinShareButton,
   WhatsappShareButton,
} from 'react-share';

type ShareVoucherProps = {
   shareTitle: string;
   shareDescription: string;
   custom?: boolean;
   className?: string;
};

/**
 * This component is a share button that presents the user with a modal to share
 * a code using several social media platforms. The button style is accepted as
 * a prop.
 */
const ShareVoucher: FC<ShareVoucherProps> = ({
   shareTitle,
   shareDescription,
   className,
   custom,
   children,
}) => {
   const [sharing, setShare] = useState(false);

   const share = () => {
      if (navigator.share) {
         navigator.share({
            url: window.location.href,
            title: shareTitle,
            text: shareDescription,
         });
      } else {
         setShare(true);
      }
   };

   const stopSharing = () => setShare(false);
   return (
      <div>
         {custom ? (
            <button onClick={share} className={className}>
               {children}
            </button>
         ) : (
            <Button type="secondary" className="px-5 py-1 border-0" onClick={share}>
               {children}
            </Button>
         )}
         <Modal size="xs" node="share" onClickOutside={stopSharing} open={sharing}>
            <ModalBody className="px-6 py-4">
               <div className="grid grid-cols-5 gap-2 ">
                  <FacebookShareButton
                     className="flex justify-center focus:outline-none focus:ring-1"
                     url={'https://halayalla.com'}
                     hashtag="#halayalla"
                     quote={shareDescription}>
                     <FacebookIcon round size={48} />
                  </FacebookShareButton>
                  <WhatsappShareButton
                     className="flex justify-center"
                     url={'https://halayalla.com'}
                     title={shareDescription}
                     separator={' | '}>
                     <WhatsappIcon round size={48} />
                  </WhatsappShareButton>
                  <TwitterShareButton
                     className="flex justify-center"
                     url={'https://halayalla.com'}
                     title={shareTitle}
                     hashtags={['halyalla']}
                     related={['halayalla']}>
                     <TwitterIcon round size={48} />
                  </TwitterShareButton>
                  <LinkedinShareButton
                     className="flex justify-center"
                     url={'https://halayalla.com'}
                     title={shareTitle}
                     summary={shareDescription}
                     source="HalaYalla">
                     <LinkedinIcon round size={48} />
                  </LinkedinShareButton>
                  <EmailShareButton
                     className="flex justify-center"
                     url={'https://halayalla.com'}
                     subject={shareTitle}
                     body={shareDescription}>
                     <EmailIcon round size={48} />
                  </EmailShareButton>
               </div>
               <div className="flex justify-center w-full mt-5 text-center">
                  <Button onClick={stopSharing} className="px-10 py-2" type="secondary">
                     <Translate id="common:cancel" />
                  </Button>
               </div>
            </ModalBody>
         </Modal>
      </div>
   );
};

export default ShareVoucher;
